import { fn } from '@ember/helper';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import GeneralDropdownsDropdownYield from 'lumen/components/general/dropdowns/dropdown-yield';
import GeneralDropdownsTriggersTriggerDropdownBasic from 'lumen/components/general/dropdowns/triggers/trigger-dropdown-basic';
import SettingsTransactionMappingFilterPill from 'lumen/components/settings/transaction-mapping/filter-pill';
import type { FilterOption } from 'lumen/controllers/market/settings/transaction-mapping';
import type { FilterId } from 'lumen/utils/constants/transaction-mapping/constants';
import { FILTER_TRANSLATION_KEYS } from 'lumen/utils/constants/transaction-mapping/translation-constants';

interface SettingsTransactionMappingFilterBarSignature {
  Args: {
    filters: FilterOption[];
    onRemoveFilterClicked: (filter: FilterOption) => void;
  };
}

const NUMBER_OF_VISIBLE_FILTERS = 5;

export default class SettingsTransactionMappingFilterBar extends Component<SettingsTransactionMappingFilterBarSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  translateFilterId = (filterId: FilterId) =>
    this.intl.t(FILTER_TRANSLATION_KEYS[filterId]);

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get extraFilters() {
    return this.args.filters.slice(NUMBER_OF_VISIBLE_FILTERS);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get visibleFilters() {
    return this.args.filters.slice(0, NUMBER_OF_VISIBLE_FILTERS);
  }

  <template>
    <div class="flex items-center gap-100" data-test-id="filter-bar">
      {{#each this.visibleFilters as |filter|}}
        <SettingsTransactionMappingFilterPill
          @label={{this.translateFilterId filter.id}}
          @onRemove={{fn @onRemoveFilterClicked filter}}
          @value={{filter.label}}
        />
      {{/each}}

      {{#if this.extraFilters}}
        <div class="filter-bar__extra-dropdown relative">
          <GeneralDropdownsDropdownYield
            {{! @glint-expect-error: Incorrect type }}
            @selected={{t "general.amount_more" count=this.extraFilters.length}}
            @triggerComponent={{GeneralDropdownsTriggersTriggerDropdownBasic}}
            {{! @glint-expect-error: Incorrect type }}
            data-test-id="filter-bar-dropdown-extra-filters"
          >
            <div class="m-200 flex flex-col gap-100">
              {{#each this.extraFilters as |filter|}}
                <SettingsTransactionMappingFilterPill
                  @label={{this.translateFilterId filter.id}}
                  @onRemove={{fn @onRemoveFilterClicked filter}}
                  @value={{filter.label}}
                />
              {{/each}}
            </div>
          </GeneralDropdownsDropdownYield>
        </div>
      {{/if}}
    </div>
  </template>
}
